// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../index';

import { gql } from 'graphql-tag';
import { MoneyFragmentDoc } from '../../fragments/money.fragment.generated';
export const AffirmFinanceOptionsFragmentDoc = gql`
    fragment affirmFinanceOptions on AffirmFinanceOption {
  __typename
  price {
    ...money
  }
}
    ${MoneyFragmentDoc}`;